// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1342":"09e7cd3a","2336":"440000c1","2483":"6bc6ce96","4914":"52b271ab","6672":"2157b069","7810":"449cfa34","8689":"58f23d9a"}[chunkId] + ".chunk.js";
};